import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useAccountSetup } from './hooks';
import MultiStepProgressBar from './MultiStepProgressBar';
import AccountInfo from './AccountInfo';
import PasswordReset from './PasswordReset';
import SecurityQuestion from './SecurityQuestion';
import Disclaimer from './Disclaimer';
import TermsAndPolicy from './TermsAndPolicy';
import SetupSuccess from './SetupSuccess';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './AccountSetup.scss';

const AccountSetup = () => {
  const {
    currentStep,
    schema,
    passwordSchema,
    securityQuestionschema,
    passwordRules,
    showPassword,
    showConfirmPassword,
    userData,
    formData,
    privacyPolicyContent,
    termsConditionContent,
    isButtonDisable,
    nextStep,
    prevStep,
    setShowPassword,
    setShowConfirmPassword,
    handleInput,
    updateUser,
    getStepTitle,
    selectedQuestionValues,
    handleQuestionValChange,
  } = useAccountSetup();

  return (
    <Container className="account-setup-container">
      <Row>
        <Col>
          {currentStep !== 6 && (
            <>
              <div className="page-header d-flex align-items-center">
                <h1 className="register-header mb-2">{getStepTitle()}</h1>
              </div>
              <MultiStepProgressBar currentStep={currentStep} />
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="page-content-container">
            {currentStep === 1 && (
              <AccountInfo
                currentStep={currentStep}
                nextStep={nextStep}
                schema={schema}
                userData={userData}
                formData={formData}
                handleInput={handleInput}
              />
            )}

            {currentStep === 2 && (
              <PasswordReset
                currentStep={currentStep}
                nextStep={nextStep}
                passwordSchema={passwordSchema}
                passwordRules={passwordRules}
                showPassword={showPassword}
                showConfirmPassword={showConfirmPassword}
                setShowPassword={setShowPassword}
                setShowConfirmPassword={setShowConfirmPassword}
                formData={formData}
                handleInput={handleInput}
              />
            )}

            {currentStep === 3 && (
              <SecurityQuestion
                currentStep={currentStep}
                nextStep={nextStep}
                securityQuestionschema={securityQuestionschema}
                handleQuestionValChange={handleQuestionValChange}
                selectedQuestionValues={selectedQuestionValues}
                formData={formData}
                handleInput={handleInput}
                isButtonDisable={isButtonDisable}
              />
            )}

            {currentStep === 4 && (
              <Disclaimer
                currentStep={currentStep}
                nextStep={nextStep}
                content={privacyPolicyContent}
              />
            )}

            {currentStep === 5 && (
              <TermsAndPolicy
                currentStep={currentStep}
                nextStep={nextStep}
                updateUser={updateUser}
                termsContent={termsConditionContent}
              />
            )}

            {currentStep === 6 && (
              <SetupSuccess currentStep={currentStep} nextStep={nextStep} />
            )}
          </div>
        </Col>
      </Row>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </Container>
  );
};

export default AccountSetup;
